
import * as Builder from './Builder';
import * as Sidebar from './Sidebar';
import * as BaseLayout from './BaseLayout';
import * as StartPage from './StartPage';

import * as Global from './Global';

import * as Screen from './Screens';


export default {
  Builder,
  Sidebar,
  BaseLayout,
  StartPage,

  Screen,
  Global,
}